import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=0beeed42&scoped=true&"
import script from "./activity.vue?vue&type=script&lang=js&"
export * from "./activity.vue?vue&type=script&lang=js&"
import style0 from "../../../static/css/activity.css?vue&type=style&index=0&id=0beeed42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beeed42",
  null
  
)

export default component.exports